import React from 'react';

const buttonVariants = {
  variant: {
    default: "bg-primary text-white hover:bg-primary-700 shadow-md hover:shadow-lg",
    destructive: "bg-error text-white hover:bg-error-600 shadow-md hover:shadow-lg",
    outline: "border border-text-light/30 bg-transparent hover:bg-background-secondary text-text-primary hover:text-primary",
    secondary: "bg-background-secondary text-text-primary hover:bg-text-light/20 dark:bg-gray-700 dark:text-gray-100 dark:hover:bg-gray-600",
    ghost: "hover:bg-background-secondary text-text-primary hover:text-primary",
    link: "text-highlight underline-offset-4 hover:underline hover:text-primary",
    success: "bg-success text-white hover:bg-success-600 shadow-md hover:shadow-lg",
    warning: "bg-warning text-white hover:bg-warning-600 shadow-md hover:shadow-lg",
  },
  size: {
    default: "h-11 md:h-10 px-4 py-2",
    sm: "h-10 md:h-9 rounded-md px-3",
    lg: "h-12 md:h-11 rounded-md px-6 md:px-8",
    icon: "h-11 w-11 md:h-10 md:w-10",
  },
};

const Button = React.forwardRef(({
  className = '',
  variant = 'default',
  size = 'default',
  children,
  ...props
}, ref) => {
  const baseClasses = "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/20 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50";

  const variantClasses = buttonVariants.variant[variant] || buttonVariants.variant.default;
  const sizeClasses = buttonVariants.size[size] || buttonVariants.size.default;

  const classes = `${baseClasses} ${variantClasses} ${sizeClasses} ${className}`.trim();

  return (
    <button
      className={classes}
      ref={ref}
      {...props}
    >
      {children}
    </button>
  );
});

Button.displayName = "Button";

export { Button }; 